module.exports = __webpack_public_path__ + "static/pandesal-2396e2827d0eedc35adb39480d034911.jpg";